import React from 'react';
import styled from 'styled-components';

const Shell = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.gray[100]};
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex: 1;
  max-width: ${({ theme }) => theme.container};
  width: 100%;
  margin: 0 auto;
  padding: 24px 16px;
`;

const AdminLayout = ({ children }) => (
  <Shell>
    <Content>
      {children}
    </Content>
  </Shell>
);

export default AdminLayout;
